import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-volumes',
  templateUrl: './volumes.component.html',
  styleUrls: ['./volumes.component.scss']
})
export class VolumesComponent implements OnInit {
// todo unused
  constructor() {
  }

  ngOnInit() {
  }

}
